@if (state === 'loading') {
  @if (!qc) {
    <app-spinner></app-spinner>
  }
  @if (qc && !stream) {
    No suitable live stream available.
  }
}
@if (state === 'offline') {
  <tyt-offline message="You need an Internet connection to watch live. Check your connectivity and try again."></tyt-offline>
}